import { create } from 'zustand'

import Shared from '@/shared'
import type { MyTicketStates, MyTicketActions } from '@/shared/states/myTicket/types'

export const useMyTicketStore = create<MyTicketStates & MyTicketActions>((set) => ({
  myTicketData: null,
  authData: {
    token: null,
    guestCode: null,
    guestSeq: null,
    type: null
  },

  setMyTicketData: (payload) => set({ myTicketData: payload }),
  setAuthData: (payload) => set({ authData: payload })
}))

export const myTicketNonNullableSelector = (store: MyTicketStates & MyTicketActions) => {
  const { myTicketData, authData } = store

  if (!myTicketData) {
    throw new Shared.Errors.ClientDataNullError('주차권 데이터가 존재하지 않습니다.')
  }

  return {
    myTicketData,
    authData
  }
}
